/* The hero visual: a CSS/SVG quote document (line items with negotiated
   per-line prices) → flow arrow → a real Shopify draft order.
   This is the truthful core loop: quote → buyer accepts → draftOrderCreate.
   Pure markup + the design-system CSS. No images, no JS. */
import { Receipt, Scan, Sparkles } from "./icons";

const LINES = [
  { name: "Kraft shipping box · 12×9×4", sku: "BX-1294", qty: "×500", was: "$1.40", now: "$1.09" },
  { name: "Bubble mailer, recycled", sku: "ML-0080", qty: "×1,000", was: "$0.62", now: "$0.48" },
  { name: "Pallet wrap, 18\" stretch", sku: "PW-1801", qty: "×24", was: "$28.00", now: "$22.50" },
];

function FlowArrow() {
  return (
    <svg
      className="qd-flow-arrow"
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M13 2v26" strokeDasharray="3 4" />
      <path d="m6 22 7 8 7-8" />
    </svg>
  );
}

export function QuoteMotif() {
  return (
    <div className="qd-motif" role="img" aria-label="A B2B quote with negotiated per-line pricing converts into a real Shopify draft order when the buyer accepts.">
      <span className="qd-motif__badge qd-motif__badge--po">
        <Scan width={16} height={16} />
        PO PDF parsed
      </span>
      <span className="qd-motif__badge qd-motif__badge--ai">
        <Sparkles width={16} height={16} />
        AI counter ready
      </span>

      <article className="qd-doc" aria-hidden>
        <div className="qd-doc__top">
          <div>
            <div className="qd-doc__label">Quote</div>
            <div className="qd-doc__no">Q-1042</div>
          </div>
          <span className="qd-chip qd-chip--amber">
            <span className="qd-chip__dot" />
            Sent to buyer
          </span>
        </div>

        <ul className="qd-doc__lines">
          {LINES.map((l) => (
            <li className="qd-line" key={l.sku}>
              <span>
                <span className="qd-line__name">{l.name}</span>
                <span className="qd-line__sku">{l.sku}</span>
              </span>
              <span className="qd-line__qty">{l.qty}</span>
              <span className="qd-line__price">
                <s>{l.was}</s>
                {l.now}
              </span>
            </li>
          ))}
        </ul>

        <div className="qd-doc__total">
          <span>Negotiated total</span>
          <span>$1,283.00</span>
        </div>
      </article>

      <div className="qd-motif__flow">
        <FlowArrow />
        <div className="qd-order">
          <span className="qd-order__icon" aria-hidden>
            <Receipt width={20} height={20} />
          </span>
          <span className="qd-order__meta">
            <b>Draft order #1042</b>
            <span>draftOrderCreate · paid via checkout</span>
          </span>
          <span className="qd-chip qd-chip--green" style={{ marginLeft: "auto" }}>
            <span className="qd-chip__dot" />
            Accepted
          </span>
        </div>
      </div>
    </div>
  );
}
